import type { BreadcrumbItem } from '../../contexts/BreadcrumbContext'

/** The `nav.*` key of each page of the group space, by its path under `/group`. */
const PAGE_NAV_KEYS: Record<string, string> = {
    '': 'consolidated',
    perimeters: 'perimeters',
    sites: 'sites',
    governance: 'governance',
    definitions: 'definitions',
    criteria: 'criteria',
    access: 'access',
}

/**
 * The trail of a group space page: Home > Group steering > the page, and the
 * family on the consolidated view (the one it shows, so the first one when
 * the URL names none). Unknown paths stop at the space.
 */
export function groupBreadcrumbs(opts: {
    org: string
    pathname: string
    home: string
    space: string
    navLabel: (key: string) => string
    familyLabel?: string
}): BreadcrumbItem[] {
    const { org, pathname, home, space, navLabel, familyLabel } = opts
    const root = `/${org}/group`
    const crumbs: BreadcrumbItem[] = [{ title: home, path: `/${org}` }, { title: space, path: root }]

    const page = pathname.startsWith(root) ? pathname.slice(root.length).replace(/^\/+|\/+$/g, '') : ''
    const key = PAGE_NAV_KEYS[page]
    if (!key) return crumbs

    crumbs.push({ title: navLabel(key), path: page ? `${root}/${page}` : root })
    if (page === '' && familyLabel) crumbs.push({ title: familyLabel })

    // The page you are on is not a link.
    delete crumbs[crumbs.length - 1].path
    return crumbs
}
